module.exports = __webpack_public_path__ + "img/money-active-1.064523c2.png";